import React, { useState, useRef, useEffect } from 'react';
import { HashRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { LogIn, UserPlus, Zap, AlertTriangle, WifiOff } from 'lucide-react';
import blurTop from '../../assets/splashScreen/Blur.svg'
import { API_BASE_URL } from '../../config/api';

// function SigninPage() {

//     const navigate = useNavigate();

//     // Handler for the Sign In button
//     const handleSignIn = (e) => {
//         e.preventDefault();
//         // In a real app: validate credentials, set auth state, then navigate.
//         console.log('Attempting Sign In...');
//         // Navigates to a placeholder dashboard after successful sign in
//         navigate("/home"); 
//     }

//     return (
//         <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">

//             {/* Image for aesthetic blur background */}
//             <img
//                 src={blurTop}
//                 alt="Decorative background blur"
//                 className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
//             />

//             <h1 className="text-3xl font-bold text-[#307CF8]">Sign in</h1>
//             <p className="text-gray-500 text-sm mt-1">Welcome back! Sign in to continue</p>

//             <form className="mt-8 space-y-6 flex-1 flex flex-col justify-center">

//                 {/* Email */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Email Address</label>
//                     <input
//                         type="email"
//                         placeholder="name@email.com"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm flex justify-between items-center">
//                         <span>Password</span>
//                         <span 
//                             className="text-blue-600 text-xs font-semibold cursor-pointer hover:underline"
//                             onClick={() => console.log('Navigate to Forgot Password')}
//                         >
//                             Forgot Password?
//                         </span>
//                     </label>
//                     <input
//                         type="password"
//                         placeholder="Enter your password"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Submit Button */}
//                 <button 
//                     type="submit"
//                     className="w-full bg-blue-600 py-3 rounded-xl font-semibold text-white mt-10 shadow-lg shadow-blue-500/50 hover:bg-blue-700 transition"
//                     onClick={handleSignIn} 
//                 >
//                     <LogIn className="w-5 h-5 inline mr-2 align-sub" />
//                     Sign In
//                 </button>
//             </form>

//             {/* Sign up link */}
//             <p className="text-center text-gray-600 text-sm mt-auto pt-6">
//                 Don't have an account?{" "}
//                 <span 
//                     className="text-blue-600 font-semibold cursor-pointer hover:underline"
//                     onClick={() => navigate("/signup")}
//                 >
//                     Sign up
//                 </span>
//             </p>
//         </div>
//     );
// }



// // --- 1. Signin Component (For Existing Users: Email & Password) ---
// function SigninPage({setAuthToken}) {

//     const navigate = useNavigate();
//    const API_URL = "https://psh-admin.zolute.xyz/api/auth/login";

//     const [formData, setFormData] = useState({
//         email: '', // Initial value based on user request
//         password: '',    // Initial value based on user request
//     });
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     // Handler for the Sign In button

//     // Handler for the Sign In button
//     const handleSignIn = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setIsLoading(true);

//         try {
//             const payload = {
//                 email: formData.email,
//                 password: formData.password,
//             };

//             // Using the provided API URL for login
//             const response = await fetch(API_URL, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(payload),
//             });

//             const result = await response.json();

//             if (response.ok) {
//                 console.log('Sign In Successful. Received Token/Data:', result);

//                 // IMPORTANT FIX: Set the received token in the App component state
//                 // Assuming the token is located at result.access_token or similar.
//                 // If the API response structure is different, you must adjust this line.
//                 const token = result.data.token; 

//                 if (token) {
//                     setAuthToken(token);

//                     console.log(token,'usertoken set' )// <--- This is the key fix
//                     navigate("/home"); // Navigates to the protected home route
//                 } else {
//                     setError('Sign in successful but no authentication token was received.');
//                 }
//             } else {
//                 // Handle API error messages (e.g., invalid credentials)
//                 const errorMessage = result.message || JSON.stringify(result.errors || result) || 'Sign in failed due to an unknown error.';
//                 setError(errorMessage);
//                 console.error('API Error:', result);
//             }
//         } catch (err) {
//             console.error('Network Error:', err);
//             setError('Network error or server unreachable. Please check the API URL and status.');
//         } finally {
//             setIsLoading(false);
//         }
//     }

//     return (
//         <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">

//             {/* Image for aesthetic blur background */}
//             <img
//                 src={blurTop}
//                 alt="Decorative background blur"
//                 className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
//             />

//             <h1 className="text-3xl font-bold text-[#307CF8]">Sign in</h1>
//             <p className="text-gray-500 text-sm mt-1">Welcome back! Sign in to continue</p>

//             {/* Error Message Display */}
//             {error && (
//                 <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-xl flex items-start text-sm">
//                     <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
//                     <p className="font-medium">Error: {error}</p>
//                 </div>
//             )}

//             <form className="mt-8 space-y-6 flex-1 flex flex-col justify-center" onSubmit={handleSignIn}>

//                 {/* Email */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Email Address</label>
//                     <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         placeholder="name@email.com"
//                         required
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm flex justify-between items-center">
//                         <span>Password</span>
//                         <span 
//                             className="text-blue-600 text-xs font-semibold cursor-pointer hover:underline"
//                             onClick={() => console.log('Navigate to Forgot Password')}
//                         >
//                             Forgot Password?
//                         </span>
//                     </label>
//                     <input
//                         type="password"
//                         name="password"
//                         value={formData.password}
//                         onChange={handleChange}
//                         placeholder="Enter your password"
//                         required
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Submit Button */}
//                 <button 
//                     type="submit"
//                     className={`w-full py-3 rounded-xl font-semibold text-white mt-10 shadow-lg transition ${
//                         isLoading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/50'
//                     }`}
//                     disabled={isLoading}
//                 >
//                     {isLoading ? (
//                         'Signing In...'
//                     ) : (
//                         <>
//                             <LogIn className="w-5 h-5 inline mr-2 align-sub" />
//                             Sign In
//                         </>
//                     )}
//                 </button>
//             </form>

//             {/* Sign up link */}
//             <p className="text-center text-gray-600 text-sm mt-auto pt-6">
//                 Don't have an account?{" "}
//                 <span 
//                     className="text-blue-600 font-semibold cursor-pointer hover:underline"
//                     onClick={() => navigate("/signup")}
//                 >
//                     Sign up
//                 </span>
//             </p>
//         </div>
//     );
// }
// export default SigninPage;



// --- 1. SigninPage Component ---
function SigninPage({ setAuthToken }) {

    const navigate = useNavigate();
    const API_URL = `${API_BASE_URL}/auth/login`;


    const [emailNotVerified, setEmailNotVerified] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [emailResent, setEmailResent] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    // State to hold the token locally until we can safely navigate
    const [localToken, setLocalToken] = useState(null);
    const [localTokenemail, setLocalTokenemail] = useState(null);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // EFFECT: Navigate only after the token has been successfully set locally
    useEffect(() => {
        if (localToken) {
            // 💡 NEW: Persist the token in localStorage
            localStorage.setItem('authToken', localToken);

            setAuthToken(localToken);

            const timer = setTimeout(() => {
                navigate("/home");
            }, 0);

            return () => clearTimeout(timer);
        }
    }, [localToken, setAuthToken, navigate]);


    const handleSignIn = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            const payload = {
                email: formData.email,
                password: formData.password,
            };

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            // if (response.ok && result.status === 'SUCCESS') {
            //     const token = result.data?.token || result.access_token; 

            //     if (token) {
            //         setLocalToken(token); 
            //     } else {
            //         setError('Sign in successful but no authentication token was received.');
            //     }
            // } 
            if (response.ok) {

                const token = result.data?.token;
                console.log(token, 'local token')
                const user = result.data?.user;


                 if (token) {
        setLocalTokenemail(token);}
                // ❌ EMAIL NOT VERIFIED
                if (!user?.emailVerifiedAt) {
                    setEmailNotVerified(true);
                    setUserEmail(user.email);
                    setIsLoading(false);
                    return; // STOP LOGIN
                }

                // ✅ EMAIL VERIFIED
                if (token) {
                    setLocalToken(token);

                    console.log(localToken, 'local token')
                } else {
                    setError("Authentication token not received.");
                }
            }
            else {
                const errorMessage = result.message || JSON.stringify(result.errors || result) || 'Sign in failed due to an unknown error.';
                setError(errorMessage);
            }
        } catch (err) {
            // 💡 ENHANCEMENT: Specific network error message
            if (err instanceof TypeError && err.message.includes('Failed to fetch')) {
                setError('Network error or server unreachable. Please check your connection.');
            } else {
                setError('An unexpected error occurred: ' + err.message);
            }
        } finally {
            if (!localToken) {
                setIsLoading(false);
            }
        }
    }




    const handleResendEmail = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/email/verification-notification`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localTokenemail}`
                },
                body: JSON.stringify({
                    email: userEmail
                })
            });

            const data = await response.json();

            if (response.ok) {
                setEmailNotVerified(false);   // hide resend block
                setEmailResent(true);         // show message
            } else {
                setError(data.message || "Failed to resend email.");
            }

        } catch (error) {
            setError("Network error while sending verification email.");
        }
    };
    return (
        <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden max-w-md mx-auto">
            <img
                src={blurTop}
                alt="Decorative background blur"
                className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
                style={{ zIndex: 0 }}
            />

            <div className="relative z-10">
                <h1 className="text-3xl font-bold text-[#307CF8]">Sign in</h1>
                <p className="text-gray-500 text-sm mt-1">Welcome back! Sign in to continue</p>

                {error && (
                    <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-xl flex items-start text-sm">
                        <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
                        <p className="font-medium">Error: {error}</p>
                    </div>
                )}

                {emailResent && (
                    <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-xl text-sm">
                        Verification email sent successfully.
                        Please verify your email and login again.
                    </div>
                )}
                {emailNotVerified && (
                    <div className="mt-4 p-4 bg-yellow-100 border border-yellow-400 rounded-xl text-sm">
                        <p className="font-semibold text-yellow-800">
                            Email not verified
                        </p>
                        <p className="text-yellow-700">
                            Please verify your email to continue.
                        </p>

                        <button
                            onClick={handleResendEmail}
                            className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg"
                        >
                            Resend Verification Email
                        </button>
                    </div>
                )}
                <form className="mt-8 space-y-6 flex-1 flex flex-col justify-center" onSubmit={handleSignIn}>
                    <div>
                        <label className="text-gray-600 text-sm">Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="name@email.com"
                            required
                            className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                        />
                    </div>

                    <div>
                        <label className="text-gray-600 text-sm flex justify-between items-center">
                            <span>Password</span>
                            <span
                                className="text-blue-600 text-xs font-semibold cursor-pointer hover:underline"
                                onClick={() => navigate("/forgot-password")}
                            >
                                Forgot Password?
                            </span>
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            required
                            className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                        />
                    </div>

                    <button
                        type="submit"
                        className={`w-full py-3 rounded-xl font-semibold text-white mt-10 shadow-lg transition ${isLoading || localToken ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/50'
                            }`}
                        disabled={isLoading || !!localToken}
                    >
                        {isLoading || localToken ? (
                            'Signing In & Redirecting...'
                        ) : (
                            <>
                                <LogIn className="w-5 h-5 inline mr-2 align-sub" />
                                Sign In
                            </>
                        )}
                    </button>
                </form>

                <p className="text-center text-gray-600 text-sm mt-auto pt-6">
                    Don't have an account?{" "}
                    <span
                        className="text-blue-600 font-semibold cursor-pointer hover:underline"
                        onClick={() => navigate("/signup")}
                    >
                        Sign up
                    </span>
                </p>
            </div>
        </div>
    );
}
export default SigninPage;
